<template>
  <!-- label selection menu on small devices or if more than 5 labels-->
  <div class="d-flex caption align-center touch">
    <v-menu v-if="smAndDown" bottom transition="slide-y-transition" offset-y close-on-content-click>
      <template v-slot:activator="{ on, attrs }">
        <v-btn small rounded class="d-flex mr-0" v-bind="attrs" v-on="on" :color="selectedItemId ? theme.elements.btnColor : ''" :dark="smAndDown">
          {{ selectedItemText }}
        </v-btn>
      </template>

      <v-list dense class="px-2" style="max-width: 400px">
        <labels :labels="labels" :displayFilterIcon="false" v-model="selectedItemId" :displayProperty="displayProperty"></labels>
        <v-chip class="mr-2" text :disabled="selectedItemId === null" @click="selectedItemId = null">
          <v-icon small :color="theme.elements.activeColor" class="mr-2">mdi-filter-off</v-icon>
          {{ $t('label.removeLabelFilter') }}
        </v-chip>
      </v-list>
    </v-menu>
    <!-- labels on md and up devices-->
    <labels v-else :labels="labels" v-model="selectedItemId" :displayProperty="displayProperty" :displayFilterIcon="false"></labels>
  </div>
</template>

<script>
import common from '@/mixins/common';
import Labels from './Labels.vue';

export default {
  name: 'LabelGroup',
  components: {
    Labels,
  },
  mixins: [common],
  props: {
    labels: Array,
    value: Number,
    displayProperty: String,
  },
  mounted() {
    console.debug('labels', this.labels);
  },
  data() {
    return {
      selectedItemId: this.value,
    };
  },
  computed: {
    selectedItemText() {
      // console.debug('get selected item text from selectedItemId', this.selectedItemId, this.labels);
      // console.debug('this.labels[this.selectedItemId', this.labels[this.selectedItemId]);
      let label = this.labels.find((l) => l.id === this.selectedItemId);
      return label ? label[this.displayProperty] : this.$t('label.noLabelFilter');
    },
  },

  watch: {
    selectedItemId(newValue, oldValue) {
      console.debug('selectedItemId', newValue);
      this.$emit('input', newValue);
    },
  },
};
</script>

<style></style>
